//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import DetailInfo from '~/components/detail/mobile/detail_info'
import ComparePrice from '~/components/detail/mobile/compare_price'
export default {
  name: 'CoinHeader',
  components: {
    DetailInfo,
    ComparePrice
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    },
    digitalData: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      buyDollarPrice: 'coins/buyDollarPrice',
      trends: 'coins/trends',
      isGuest: 'auth/isGuest',
      watchList: 'watchList/watchList'
    }),
    inWatchList () {
      if (this.data) {
        const index = this.watchList.findIndex(i => i.symbol === this.data.symbol)
        if (index >= 0) {
          return true
        }
        return false
      }
      return false
    }
  },
  methods: {
    watchListClick () {
      if (this.isGuest) {
        const router = this.$router.resolve({ path: '/my/auth/login' })
        window.open(router.href, '_self')
      } else {
        this.$store.dispatch(this.inWatchList ? 'watchList/removeFavorite' : 'watchList/addFavorite', this.data)
      }
    }
  }
}
